import { PrintArea, PrintType, ProductType } from '@/types';
import { getRestrictions } from '@/utils/embroideryRestrictions';
import { isEmbroideryMode } from '@/utils/params';
import { getIsSingleConfigurationPrintType } from '@/model/printType/getIsSingleConfigurationPrintType';

export const getDefaultBox = (
  {
    boundary: {
      size: { width: boundaryWidth, height: boundaryHeight },
    },
    id: printAreaId,
  }: PrintArea,
  printType: PrintType,
  productType: ProductType
) => {
  const defaultBox = getIsSingleConfigurationPrintType(printType)
    ? {
        x: 0,
        y: 0,
        width: boundaryWidth,
        height: boundaryHeight,
      }
    : {
        x: boundaryWidth / 6,
        y: boundaryHeight / 7,
        width: (boundaryWidth * 4) / 6,
        height: (boundaryHeight * 5) / 7,
      };

  if (isEmbroideryMode()) {
    const [embroideryRestrictionWidth, embroideryRestrictionHeight] = getRestrictions(
      productType,
      printAreaId
    );

    if (embroideryRestrictionWidth > defaultBox.width) {
      return defaultBox;
    }

    return {
      x: boundaryWidth / 2 - embroideryRestrictionWidth / 2,
      y: boundaryHeight / 7,
      // there are restrictions that as width as the printarea max boundary. If we set the width to this value
      // it will fail validation as the maxScale check will at a tiny Epsilon to its max scale which turns that > 1
      // to avoid this we make the size slightly smaller
      width: embroideryRestrictionWidth * 0.99,
      height: embroideryRestrictionHeight * 0.99,
    };
  }

  return defaultBox;
};
